export default __webpack_public_path__ + "static/media/img (1).0fde1169.jpg";